import { useMutation, useQuery } from '@tanstack/react-query'

import type { UseMutationResult, UseQueryResult } from '@tanstack/react-query'
import type { IGlossaryEntry, IGlossaryEntryCreate } from '~/types/glossary'

import { createGlossaryEntry, deleteGlossaryEntry, getGlossary, updateGlossaryEntry } from '~/api/glossary'

////////// KEYS //////////

export const keys = {
  all: ['glossary'] as const,
  details: (appId?: string) => [...keys.all, 'details', appId] as const,
  list: () => [...keys.all, 'list'] as const,
}

////////// QUERIES //////////

export const useGlossaryListQuery = (): UseQueryResult<IGlossaryEntry[]> => {
  return useQuery({ queryFn: getGlossary, queryKey: keys.list() })
}

////////// MUTATIONS //////////

export const useCreateGlossaryEntryMutation = (): UseMutationResult<void, unknown, IGlossaryEntryCreate> => {
  return useMutation({ mutationFn: createGlossaryEntry })
}

export const useUpdateGlossaryEntryMutation = (): UseMutationResult<void, unknown, IGlossaryEntry> => {
  return useMutation({ mutationFn: updateGlossaryEntry })
}

export const useDeleteGlossaryEntryMutation = (): UseMutationResult<void, unknown, string> => {
  return useMutation({ mutationFn: deleteGlossaryEntry })
}
